import './App.css';

import Board from './board/board'

function App() {
  return (
    <div className="App">
      <header className="App-header">
       <p>sorting algorithms visualizer</p>
      </header>
      <Board />
    </div>
  );
}

export default App;
